import { styled, SxProps, Theme } from '@mui/material';
import { ImgHTMLAttributes } from 'react';

export type Props = ImgHTMLAttributes<HTMLImageElement> & {
  rounded?: boolean;
  sx?: SxProps<Theme>;
};

const Root = styled('img', {
  shouldForwardProp: (prop) => prop !== 'rounded' && prop !== 'sx',
})<Props>(({ theme, rounded }) => {
  return {
    borderRadius: rounded ? theme.shape.borderRadius * 2 : 'inherit',
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  };
});
export const Image = (props: Props) => {
  return <Root loading="lazy" {...props} />;
};
